import React from "react";
import {
  Button,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { observer } from "mobx-react-lite";
import DialogContentText from "@mui/material/DialogContentText";

const DialogComponent = (props) => {

  return (
    <Dialog
      open={props.Open}
      onClose={props.OnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Alerta</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {Array.isArray(props.Message) ?
            props.Message.map(resp => (
              <Typography variant="message"><p>{resp}</p></Typography>
            )) : 
            <Typography variant="message">{props.Message}</Typography>
          }

        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.OnClose} variant="contained" color="secondary" sx={{ color: '#fff' }}>CANCELAR</Button>
        <Button
          onClick={() => {
            props.OnAccept();
          }}
          autoFocus
          variant="contained"
        >
          ACEPTAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(DialogComponent);
